import { useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';

export default () => {
  const { TextWeight, isArabic } = dynamicfunction();

  const dashboardContent = useSelector((state) => state.content?.dashboardContent);
  const lastLogin = useSelector((state) => state.content?.lastLogin);

  const getContentKey = (key) => {
      return getContentKeyAccToLang(dashboardContent, key, isArabic);
    };

  return { TextWeight, isArabic, getContentKey, lastLogin };
};
